import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { ExtrasFlightComponent } from './extras-flight.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
// import { TAPExtrasFlightComponent } from './extras-flight.tap.component';
// import { TAPFlightCheckInComponent } from '@ibe.components/booking/flights/flight-check-in/flight-check-in.tap.component';

import { INDRAExtrasFlightComponent } from './extras-flight.indra.component';
import { INDRAFlightCheckInComponent } from '@ibe.components/booking/flights/flight-check-in/flight-check-in.indra.component';

@NgModule({
	imports: [CommonModule, SVGModule, SharedModule, DirectivesModule],
	declarations: [
		ExtrasFlightComponent,
		INDRAExtrasFlightComponent,
		INDRAFlightCheckInComponent,

	],
	exports: [
		DirectivesModule,
		INDRAFlightCheckInComponent,
		INDRAExtrasFlightComponent
	]
})
export class ExtrasFlightModule { }
